<template>
  <div class="customizer-trbl">
    <label v-if="label">
      {{label}}
      <small v-if="unifiable" class="font-weight-normal ml-2" @click="basic = !basic">
        <span v-if="showBasic">Advance</span><span v-else>Basic</span>
      </small>
    </label>
    <div class="row" v-if="showBasic">
      <div class="col-6">
        <div class="input-group">
          <input :type="setInputType(oneValue)" pattern="[auto|\d+]" class="form-control text-center" v-model="oneValue">
          <div class="input-group-append">
            <span class="input-group-text" title="Pixel">PX</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div :class="{
          'col-6': true,
          'mb-4': index <= 1
        }" v-for="(rule, index) in rules" :key="rule.rule">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" :title="rule.name">{{rule.key}}</span>
          </div>
          <input :type="setInputType(amptheme[category][rule.rule])" pattern="[auto|\d+]" class="form-control text-center"
            :value="amptheme[category][rule.rule] | removeUnit"
            @input="updateAMPTheme(category, { [rule.rule]: addUnit($event.target.value, 'px') })">
          <div class="input-group-append">
            <span class="input-group-text" title="Pixel">PX</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import update from '@/mixins/update'
import filters from '@/mixins/filters'

export default {
  props: {
    label: String,
    category: String,
    prefix: String,
    suffix: {
      type: String,
      default: ''
    },
    cross: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    update,
    filters
  ],
  data: function () {
    return {
      basic: false
    }
  },
  beforeMount: function () {
    this.basic = this.unifiable
  },
  computed: {
    showBasic: function () {
      return this.basic && this.unifiable
    },
    unifiable: function () {
      const firstValue = this.removeUnit(this.amptheme[this.category][this.rules[0].rule])

      const items = this.rules.map(r => {
        const val = this.removeUnit(this.amptheme[this.category][r.rule])

        return {
          nan: isNaN(Number(val)),
          same: firstValue === val
        }
      })

      const hasNaN = items.find(item => item.nan)
      const allAreSame = items.every(item => item.same)

      return !hasNaN && allAreSame
    },
    oneValue: {
      get: function () {
        let max = -Infinity

        this.rules.forEach(rule => {
          const v = parseFloat(this.removeUnit(this.amptheme[this.category][rule.rule]))
          max = Math.max(max, v)
        })

        return max
      },
      set: function (value) {
        this.rules.forEach(rule => {
          this.updateAMPTheme(this.category, { [rule.rule]: this.addUnit(value, 'px') })
        })
      }
    },
    rules: function () {
      return this.options.map(opt => {
        const key = opt.match(/[A-Z]/g).join('')

        return {
          key,
          name: opt,
          rule: `${this.prefix}${opt.replace(' ', '')}${this.suffix}`
        }
      })
    },
    options: function () {
      if (!this.cross) return [ 'Top', 'Right', 'Bottom', 'Left' ]

      return [
        'Top Left', 'Top Right',
        'Bottom Left', 'Bottom Right'
      ]
    },
    ...mapState([ 'amptheme' ])
  }
}
</script>
